import { combineReducers } from 'redux';

import create from './create';
import list from './list';
import favoriteOwnerList from './favoriteOwnerList';

export default combineReducers({ create, list, favoriteOwnerList });
